import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class HeaderInteractionService {
  protected readonly router: Router = inject(Router);

  navigate(routes: string[]) {
    this.router.navigate(routes);
  }
}
